import { AppProvider } from "@/context/AppProvider";
import { StudyViewProvider } from "@/context/ViewContexts";
import { useStudyContext, useSubmissionContext } from "@/context/AppContext";

import StudyView from "@/views/study";

function Layout() {
  const studyContext = useStudyContext();
  const submissionContext = useSubmissionContext();

  return (
    <main className="w-full flex-1 flex flex-col items-center py-8 px-6">
      <StudyView studyContext={studyContext} submissionContext={submissionContext} />
    </main>
  );
}

export default function StudyPage() {
  return (
    <AppProvider>
      <StudyViewProvider>
        <Layout />
      </StudyViewProvider>
    </AppProvider>
  );
}
